import React from 'react';
import { motion } from 'framer-motion';
import CleanCard from './FuturisticCard';
import CleanHeading from './HolographicText';

const CleanMissionStatement = ({ variant = 'full', className = '' }) => {
  const missionContent = {
    title: "Our Mission",
    subtitle: "Connecting Clients to Tomorrow's Technology Today",
    description: "Designing, developing, and delivering advanced telecom solutions that bridge the gap between current capabilities and future possibilities.",
    keyPoints: [
      {
        title: "Innovation",
        description: "Pioneering cutting-edge telecommunications solutions",
        icon: "🚀",
        color: "text-telecom-primary"
      },
      {
        title: "Engineering Excellence",
        description: "Delivering superior technical solutions with precision",
        icon: "⚙️",
        color: "text-telecom-secondary"
      },
      {
        title: "Responsive Systems",
        description: "Creating adaptive and reliable infrastructure",
        icon: "📡",
        color: "text-telecom-accent"
      }
    ]
  };

  if (variant === 'compact') {
    return (
      <motion.div
        className={`py-12 ${className}`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="text-center">
          <CleanHeading
            size="text-xl sm:text-2xl lg:text-3xl"
            variant="primary"
            className="mb-4"
          >
            {missionContent.subtitle}
          </CleanHeading>
          <p className="text-text-secondary font-body max-w-2xl mx-auto">
            {missionContent.description}
          </p>
        </div>
      </motion.div>
    );
  }

  return (
    <section className={`py-20 bg-white ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <CleanHeading
            size="text-2xl sm:text-3xl lg:text-4xl"
            variant="primary"
            className="mb-6"
          >
            {missionContent.title}
          </CleanHeading>
          <motion.h3
            className="text-xl sm:text-2xl lg:text-3xl font-bold text-brand-primary mb-6 font-heading"
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            {missionContent.subtitle}
          </motion.h3>
          <motion.p
            className="text-lg sm:text-xl text-text-secondary font-body max-w-4xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {missionContent.description}
          </motion.p>
        </motion.div>

        {/* Key Mission Points */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {missionContent.keyPoints.map((point, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <CleanCard
                variant="default"
                className="p-6 text-center h-full"
              >
                <div className={`text-4xl mb-4 ${point.color}`}>{point.icon}</div>
                <h4 className={`text-xl font-bold font-heading mb-4 ${point.color}`}>
                  {point.title}
                </h4>
                <p className="text-text-secondary font-body leading-relaxed">
                  {point.description}
                </p>
              </CleanCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CleanMissionStatement;
